import type { MediaInner } from '@commerce-product-webcomponents/sdk';
import { SourceTypeEnums, ImageType } from '../../Molecules';
import type { IGalleryState } from './types/propsTypes';
import { ProductGalleryStyleV2Type, ScrollBehaviorEnum } from './types/enums';

const getMediaObject = (media: MediaInner, length: number) => ({
  ...media,
  id: media?.type + length,
});

export const getHeroMediaList = (list: IGalleryState[], index: number) => {
  const { length } = list;

  switch (length) {
    case 0: {
      return [
        {
          main: {
            altText: '',
            publicUrl: '',
          },
        } as IGalleryState,
      ];
    }
    case 1: {
      return list;
    }
    case 2: {
      const isZeroth = index === 0;
      const [firstItem, secondItem] = list;
      const id = 'trailing-elem';

      return isZeroth ? [secondItem, firstItem, { ...secondItem, id }] : [firstItem, secondItem, { ...firstItem, id }];
    }
    default: {
      const lastIndex = length - 1;
      const firstItem = list[index === 0 ? lastIndex : index - 1],
        secondItem = list[index],
        thirdItem = list[index === lastIndex ? 0 : index + 1];
      return [firstItem, secondItem, thirdItem];
    }
  }
};

export const getGalleryArray = (galleryList: MediaInner[]): IGalleryState[] => {
  const mediaList = JSON.parse(JSON.stringify(galleryList));
  return mediaList?.map((media: MediaInner, index: number) => getMediaObject(media, index)) || [];
};

export const getScrollPosition = (dom: HTMLElement | null) => {
  if (!dom) {
    return 0;
  }
  const [firstChild, secondChild] = dom?.children || [];
  const secondOffsetLeft = (secondChild as HTMLElement)?.offsetLeft || 0;
  const firstOffsetLeft = (firstChild as HTMLElement)?.offsetLeft || 0;
  return secondOffsetLeft - firstOffsetLeft;
};

export const getClassName = (styleType?: string) => {
  switch (styleType) {
    case ProductGalleryStyleV2Type.PRODUCT_GALLERY_MODAL:
      return 'galleryContainer-modal';
    default:
      return 'galleryContainer';
  }
};

export const getImageStyleType = (sourceKey: string) => {
  switch (sourceKey) {
    case SourceTypeEnums.MODAL_GALLERY:
      return {
        main: ImageType.PRODUCT_GALLERY_IMAGE_MODAL,
        thumbnail: ImageType.PRODUCT_GALLERY_IMAGE_MODAL_THUMBNAIL,
      };
    default:
      return {
        main: ImageType.PRODUCT_GALLERY_IMAGE,
        thumbnail: ImageType.PRODUCT_GALLERY_IMAGE_THUMBNAIL,
      };
  }
};

export const getImageId = (id: string, sourceKey: string, prefix = 'thumbnail') => [prefix, id, sourceKey].join('-');
export const getScrollBehavior = (isSmooth: boolean) =>
  isSmooth ? ScrollBehaviorEnum.SMOOTH : ScrollBehaviorEnum.AUTO;
